import { createStore } from 'vuex'
import wishes from './modules/wishes.js'
import audio from './modules/audio.js'

export default createStore({
  modules: { wishes, audio },
})
